import UnderDevelopment from '../components/UnderDevelopment/UnderDevelopment'

const AllocateDriver = () => {
  return (
    <UnderDevelopment />
  )
}

export default AllocateDriver